import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import classNames from "classnames/bind";
import Styles from "./Menu.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { IoMdArrowDropdown } from "react-icons/io";
import { useTranslation } from "react-i18next";
import { updateTab } from "../../redux/slices/app";

const cx = classNames.bind(Styles);

const Menu = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { role } = useSelector((state) => state.auth);
  const { tab } = useSelector((state) => state.app);

  useEffect(() => {
    const url = window.location.pathname;
    const lastSlash = url.lastIndexOf("/");
    const newTab = url.slice(lastSlash + 1, url.length);

    if (newTab && tab !== newTab) {
      dispatch(updateTab(newTab));
    }
  }, [location, dispatch, tab]);

  const handleUpdateTab = (tab) => {
    dispatch(updateTab(tab));
    navigate(`/mongolia/${tab}`);
  };

  const { t } = useTranslation();

  return (
    <div className={cx("menu")}>
      <ul className={cx("list-item")}>
        <li
          className={cx("item", tab === "home" ? "active" : "")}
          onClick={() => handleUpdateTab("home")}
        >
          {t("home")}
        </li>

        <li className={cx("item", tab === "detection" ? "active" : "")} onClick={() => handleUpdateTab("detection")}>
          {t("auto_detect")}
        </li>

        <li
          className={cx(
            "item",
            tab === "violation" || tab === "nonviolation" ? "active" : ""
          )}
        >
          {t("trace_violation")}
          <span className={cx("dropdown-btn")}>
            <IoMdArrowDropdown className={cx("dropdown-icon")} />
          </span>
          <ul className={cx("dropdown-content")}>
            <li
              className={cx(
                "dropdown-link",
                tab === "violation" ? "active" : ""
              )}
              onClick={() => handleUpdateTab("violation")}
            >
              {t("violation_list")}
            </li>
            <li
              className={cx(
                "dropdown-link",
                tab === "nonviolation" ? "active" : ""
              )}
              onClick={() => handleUpdateTab("nonviolation")}
            >
              {t("nonviolation_list")}
            </li>
          </ul>
        </li>

        <li
          className={cx("item", tab === "report" || tab === "submit" ? "active" : "")}
          onClick={() => handleUpdateTab("submit")}
        >
          {t("track_form")}
        </li>
        
        <li className={
          cx("item", tab === "resource-center" ? "active" : "")}
        // onClick={() => handleUpdateTab("resource-center")}
        >
          <Link to={"https://www.corporateaccountabilitytool.org/mongoliaresourcepage"} target="_blank">
            {t("resource_center")}
          </Link>
        </li>

        {role === "OPERATOR" ? (
          <li
            className={cx("item", tab === "account-management" ? "active" : "")}
            onClick={() => handleUpdateTab("account-management")}
          >
            {t("account_management")}
          </li>
        ) : (
          ""
        )}

       
      </ul>
    </div>
  );
};

export default Menu;
